import { Controller } from 'stimulus';
import mapMarkers from './mapbox_controller'

export default class extends Controller {
  connect() {}

  filterClick() {
    document.getElementsByClassName('sidebar')[0].classList.toggle('hidden');
  }

  cityList(event) {
    document.getElementById('city-list').classList.toggle('h-32');
    var targetEvent = event.target;
    if (targetEvent.innerHTML === 'See more cities') {
      targetEvent.innerHTML = 'See less cities';
    } else {
      targetEvent.innerHTML = 'See more cities';
    }
  }

  closeSidebar(event) {
    console.log('Hello');
    const sidebar = document.getElementById('sidebar');
    console.log('sidebar');
    sidebar.classList.remove('map-sidebar--open');
  }

  closeNearBySidebar(event) {
    console.log('Hello');
    const sidebar = document.getElementById('mapboxList');
    console.log('sidebar');
    sidebar.classList.add('hidden');
  }

  loadMore(event) {
    event.preventDefault()
    const loadMoreBtn = document.getElementById("loadMoreBtn")
    const nextUrl = loadMoreBtn.getAttribute("href")
    if (!nextUrl || nextUrl === "#") return

    fetch(nextUrl, { headers: { "Accept": "application/json" } })
      .then(res => res.json())
      .then(data => {
        // append new doctors

        const doctorsList = document.getElementById("LoadMoreContainer")
        doctorsList.insertAdjacentHTML("beforebegin", data.partial_html)

        // update or hide button
        if (data.next_url) {
          loadMoreBtn.setAttribute("href", data.next_url)
        } else {
          loadMoreBtn.style.display = "none"
        }
        this.bindCardHoverEvents()
      })
      .catch(err => console.error("Error loading more doctors:", err))
  }

  bindCardHoverEvents() {
    document.querySelectorAll(".map-doctor-card").forEach(card => {
      const doctorId = card.dataset.doctorId
      try {
        const mapboxControllerInstance = new mapMarkers();
        const markers = mapboxControllerInstance.getMarkers();
        console.log("Markers:", markers);
      } catch (error) {
        console.error("Error loading markers:", error);
      }
      // const markers = mapMarkers.getMarkers();
      const marker = this.markers[doctorId] // markers stored earlier

      if (marker && !card.dataset.bound) {
        card.dataset.bound = "true" // prevent duplicate listeners
        card.addEventListener("mouseenter", () => {
          marker.getElement().style.backgroundColor = "yellow"
        })
        card.addEventListener("mouseleave", () => {
          marker.getElement().style.backgroundColor = "transparent";
        })
      }
    })
  }
}
